export default {
  getUserContext: state => state.userContext,
  getHostReferenceData: state => state.hostReferenceData,
  getTenantReferenceData: state => state.tenanteReferenceData,
}
